import type { ReduxInjections } from 'src/types';

import { UPDATE_DIRTY_STATE, type FormAction, type Form } from './index';

interface FormDirtyStateUpdate {
  form: Form;
  dirty: boolean;
}

export const updateFormDirtyState =
  ({ form, dirty }: FormDirtyStateUpdate) =>
  ({ dispatch }: ReduxInjections<FormAction>) => {
    dispatch({
      type: UPDATE_DIRTY_STATE,
      payload: { form, dirty },
    });
  };
